import React, { Component } from 'react';
import MediaQuery from 'react-responsive';
import Slider from 'react-slick';
import { SampleNextArrow, SamplePrevArrow } from './arrows';

import content from '../lib/i18n';
const i18n = content('app/components/donation-steps');

import {
  Container,
  Block,
  Title,
  Images,
  Image,
  Circle,
  Slide,
  Text,
  Button,
} from './redux/components/styles/donation-steps';

export default class DonationSteps extends Component {
  renderBig(steps) {
    const [step1, step2, step3] = steps.steps;

    return (
      <Container>
        <Title as='h2' size='xl3'>
          {steps.title}
        </Title>
        <Images>
          <Image src={step1.image} />
          <Image src='https://www.paypalobjects.com/webstatic/ppgf/donationtracker/arrow1.svg' />
          <Image src={step2.image} />
          <Image src='https://www.paypalobjects.com/webstatic/ppgf/donationtracker/arrow2.svg' />
          <Image src={step3.image} />
        </Images>
        <div className='row steps-section'>
          <div className='col-sm-4'>
            <p className='circle'>
              <Circle>{step1.step}</Circle>
            </p>
            <Text as='p' size='md'>
              {step1.text}
            </Text>
          </div>
          <div className='col-sm-4'>
            <p className='circle'>
              <Circle>{step2.step}</Circle>
            </p>
            <Text
              as='p'
              size='md'
              dangerouslySetInnerHTML={{ __html: step2.text }}
            />
          </div>
          <div className='col-sm-4'>
            <p className='circle'>
              <Circle>{step3.step}</Circle>
            </p>
            <Text
              as='p'
              size='md'
              dangerouslySetInnerHTML={{ __html: step3.text }}
            />
          </div>
        </div>
      </Container>
    );
  }

  renderSmall(steps) {
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
    };

    const slides = steps.steps.map((step, index) => {
      return (
        <div key={`donation-step-${index}`}>
          <Image src={step.image} />
          <Slide>
            <Circle>{step.step}</Circle>
            <Text
              as='p'
              size='md'
              dangerouslySetInnerHTML={{ __html: step.text }}
            />
          </Slide>
        </div>
      );
    });

    return (
      <Container>
        <Title as='h2' size='xl3'>
          {steps.title}
        </Title>
        <Slider {...settings}>{slides}</Slider>
      </Container>
    );
  }

  renderButton() {
    return (
      <Button
        target='_blank'
        className='btn btn-primary'
        style={{ color: '#FFFFFF' }}
        href={i18n('label.href')}
      >
        {i18n('label.button')}
      </Button>
    );
  }

  render() {
    const steps = {
      title: i18n('label.title'),
      steps: [
        {
          step: i18n('label.step1'),
          text: i18n('label.step1-text'),
          image:
            'https://www.paypalobjects.com/webstatic/ppgf/donationtracker/step1.svg',
        },
        {
          step: i18n('label.step2'),
          text: i18n('label.step2-text'),
          image:
            'https://www.paypalobjects.com/webstatic/ppgf/donationtracker/step2.svg',
        },
        {
          step: i18n('label.step3'),
          text: i18n('label.step3-text'),
          image:
            'https://www.paypalobjects.com/webstatic/ppgf/donationtracker/step3.svg',
        },
      ],
    };

    return (
      <Block className='panel'>
        <MediaQuery minWidth={1200}>{this.renderBig(steps)}</MediaQuery>
        <MediaQuery maxWidth={1199}>{this.renderSmall(steps)}</MediaQuery>
        <Container>{this.renderButton()}</Container>
      </Block>
    );
  }
}
